<div class="select-lob d-flex justify-content-center align-items-center">
  <div class="d-flex flex-column align-items-center pb-4">
    <img src="../img/main-logo.png" alt="Logo" width="220" />

    <div class="select-lob__inner mt-3 mb-5 p-4 d-flex flex-column" style="height: 200px;">
      <div>
        <p class="select-lob__title">Select LOB</p>

        <label class="select-lob__label" for="lob">LOB</label>
        <div class="select-lob__dropdown-wrapper">
          <select id="lob" [(ngModel)]="selectedLob" name="selectedLob" class="form-control" required>
            <option value="" disabled>Select LOB</option>
            <option *ngFor="let lob of lobs" [value]="lob">{{ lob }}</option>
          </select>
        </div>
      </div>

      <!-- Right-aligned button -->
      <div class="d-flex justify-content-end mt-auto">
        <button (click)="onEnter()" class="btn btn-primary btn-sm text-uppercase px-4" [disabled]="!selectedLob">
          Enter
        </button>
      </div>
    </div>
  </div>
</div>